module.exports = __webpack_public_path__ + "img/site-logo.988d787e.svg";